// extracted by mini-css-extract-plugin
export default {"header":"sectionHeadings_header__6O8JS"};